import { twMerge } from 'tailwind-merge';

interface TabListProps {
  children?: React.ReactNode;
  className?: string;
}

export const TabList = ({ children, className }: TabListProps) => {
  return <div className={twMerge('flex gap-4', className)}>{children}</div>;
};
